module.exports = __webpack_public_path__ + "img/mask.2506c216.webp";